export default function Button() {
  return (
    <button
      className="flex h-10 w-full items-center justify-center rounded-lg bg-gray-500 py-2 font-bold text-white dark:bg-dark-200 dark:text-dark-500"
      disabled
      type="button"
    ></button>
  );
}
